import { membershipListSchema } from '@mfos/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet, apiPath } from '../../lib/api-client';

export const membershipsKey = ['workspaces'] as const;

/** Prefix of every query scoped to one workspace (invalidate it after workspace mutations). */
export const workspaceKey = (workspaceId: string) => ['workspace', workspaceId] as const;

export function workspacePath(workspaceId: string, ...segments: string[]): string {
  return apiPath('workspaces', workspaceId, ...segments);
}

export function useMemberships() {
  return useQuery({
    queryKey: membershipsKey,
    queryFn: ({ signal }) =>
      apiGet(apiPath('workspaces'), { schema: membershipListSchema, signal }),
    staleTime: 60_000,
  });
}
